import how_to_new_design from 'assets/img/how-to-section/how-to-new-design-main.svg';
import icon_1 from 'assets/img/how-to-section/icon_1.svg';
import icon_2 from 'assets/img/how-to-section/icon_2.svg';
import icon_3 from 'assets/img/how-to-section/icon_3.svg';
import type { TFunction } from 'i18next';

import { EServiceType } from 'ts/interfaces/services/service';
import { InternalFileType } from 'ts/types/file';

import edit_pdf from './assets/edit_pdf_fill.svg';

export enum ERemoveWatermarkServices {
  REMOVE_WATERMARK = 'remove_watermark'
}

export const removeWatermarkServicesList = (t: TFunction): any => {
  return [
    {
      serviceType: EServiceType.REMOVE_WATERMARK,
      mainColor: 'dark-blue',
      path: '/remove-watermark',
      key: ERemoveWatermarkServices.REMOVE_WATERMARK,
      uploadSectionImage: edit_pdf,
      name: t('landing.remove_watermark.meta.title'),
      nameKey: 'landing.remove_watermark.name',
      title: t('landing.remove_watermark.meta.title'),
      description: t('landing.remove_watermark.meta.description'),
      showTools: true,
      uploadSection: {
        from: [
          InternalFileType.PNG,
          InternalFileType.JPG,
          InternalFileType.JPEG,
          InternalFileType.BMP,
          InternalFileType.PDF
        ],
        to: [
          InternalFileType.PNG,
          InternalFileType.JPG,
          InternalFileType.JPEG,
          InternalFileType.BMP,
          InternalFileType.PDF
        ],
        headline: t('landing.remove_watermark.h1.title'),
        subtitle_1: t('landing.remove_watermark.h1.subtitle')
      },
      banner: {
        headline: t('landing.remove_watermark.CTA.title'),
        format: InternalFileType.PDF,
        buttonLabel: t('main_page.buttonLabel')
      },
      howTo: {
        headline_1: t('landing.remove_watermark.how_to.h2'),
        img: how_to_new_design,
        subtitle_1: t('landing.remove_watermark.h1.subtitle'),
        description: [
          {
            icon: icon_1,
            text: t('landing.remove_watermark.how_to.first')
          },
          {
            icon: icon_2,
            text: t('landing.remove_watermark.how_to.second')
          },
          {
            icon: icon_3,
            text: t('landing.remove_watermark.how_to.third')
          }
        ]
      },
      fag: {
        question: 'How to remove watermark from PDF or image?',
        answer:
          '1. To remove watermark from PDF or image, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF or image document using our tools and remove watermark with one click. 3. Download or share the PDF or image file.'
      },
      from: [
        InternalFileType.PNG,
        InternalFileType.JPG,
        InternalFileType.JPEG,
        InternalFileType.BMP,
        InternalFileType.PDF
      ],
      to: [
        InternalFileType.PNG,
        InternalFileType.JPG,
        InternalFileType.JPEG,
        InternalFileType.BMP,
        InternalFileType.PDF
      ],
      availableFormats: '.jpg, .jpeg, .png, .bmp, .pdf'
    }
  ];
};
